import { render, staticRenderFns } from "./ExitSystem.vue?vue&type=template&id=0228be09&scoped=true&"
import script from "./ExitSystem.vue?vue&type=script&lang=js&"
export * from "./ExitSystem.vue?vue&type=script&lang=js&"
import style0 from "./ExitSystem.vue?vue&type=style&index=0&id=0228be09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0228be09",
  null
  
)

export default component.exports